var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "aniversario" } },
    [
      _c("header", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8 offset-md-2 offset-sm-0" }, [
              _c("div", { staticClass: "form" }, [
                _c("h1", [
                  _vm._v(
                    "Você recebeu um Convite do Bem! Sua presença é muito importante, venha celebrar conosco."
                  )
                ]),
                _vm._v(" "),
                _vm.invite
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm.invite.email) +
                          " lhe enviou este convite. Confira abaixo os detalhes e não deixe de confirmar a sua presença!"
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _vm.invite
              ? _c("div", { staticClass: "intro col-md-12" }, [
                  _c("div", { staticClass: "base" }, [
                    _c("div", { staticClass: "content" }, [
                      _c("h2", [_vm._v(_vm._s(_vm.invite.title))]),
                      _vm._v(" "),
                      _c("h3", [_vm._v("Local: " + _vm._s(_vm.invite.local))]),
                      _vm._v(" "),
                      _c("h4", [_vm._v("Data: " + _vm._s(_vm.invite.date))]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Horário: " + _vm._s(_vm.invite.hour))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("Endereço: " + _vm._s(_vm.invite.address))
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.openMaps()
                            }
                          }
                        },
                        [_vm._v("Ver no Mapa")]
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm.project
              ? _c("div", { staticClass: "form col-md-12" }, [
                  _c("div", { staticClass: "content" }, [
                    _c("h5", [
                      _vm._v('"' + _vm._s(_vm.invite.description) + '".')
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Este é um Convite do Bem! O organizador do evento solicita que os valores referentes à eventuais presentes sejam revertidos para o Projeto Social que foi escolhido por ele."
                      )
                    ]),
                    _vm._v(" "),
                    _vm.msgShow
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "alert alert-danger alert-dismissible fade show",
                            attrs: { role: "alert" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.msg) +
                                "\n              "
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "close",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "alert",
                                  "aria-label": "Fechar"
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.hideMsg()
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "aria-hidden": "true" } },
                                  [_vm._v("×")]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.donate()
                          }
                        }
                      },
                      [_vm._v("Pague com PayPal")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "project" }, [
                    _c("span", [_vm._v("A doação irá para o projeto")]),
                    _vm._v(" "),
                    _c("h3", [_vm._v(_vm._s(_vm.project.Info.title))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "project-container row" }, [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("img", { attrs: { src: _vm.project.Info.image } })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("p", { staticClass: "description mt-2" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.normalizeHtml(_vm.project.Info.description)
                              ) +
                              "\n                  "
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("footer", [
        _c("div", { staticClass: "container" }, [
          _vm._m(1),
          _vm._v(" "),
          _vm.projects
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "carousel",
                      {
                        attrs: {
                          perPage: _vm.perPage,
                          navigationEnabled: _vm.navigationEnabled,
                          paginationEnabled: _vm.paginationEnabled,
                          autoplay: _vm.autoPlay
                        }
                      },
                      _vm._l(_vm.projects, function(p, k) {
                        return _c(
                          "slide",
                          {
                            key: k,
                            on: {
                              click: function($event) {
                                return _vm.openProject(p.slug)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "image" }, [
                              _c("img", { attrs: { src: p.Info.image } })
                            ]),
                            _vm._v(" "),
                            p.Categories[0] && p.Categories[0].name
                              ? _c("span", [
                                  _vm._v(_vm._s(p.Categories[0].name))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("h3", [_vm._v(_vm._s(p.Info.title))]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(p.Info.shortDescription))])
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "base" })
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "userDataModal",
          attrs: {
            "ok-only": true,
            size: "md",
            "ok-title": "Processar Doação",
            id: "userDataModal",
            title: "Informe um valor a ser doado"
          },
          on: { ok: _vm.submitFormDonation }
        },
        [
          _c(
            "form",
            {
              ref: "formPayment",
              staticClass: "donationForm",
              attrs: { method: "post" }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Valor de Doação")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "span",
                          {
                            staticClass: "input-group-text",
                            attrs: { id: "basic-addon1" }
                          },
                          [_vm._v("R$")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "money",
                            rawName: "v-money",
                            value: _vm.money,
                            expression: "money"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.donationValue,
                            expression: "donationValue"
                          }
                        ],
                        staticClass: "form-control input-value",
                        attrs: {
                          required: "",
                          type: "text",
                          name: "value",
                          placeholder:
                            "Informe o valor que deseja doar para o projeto"
                        },
                        domProps: { value: _vm.donationValue },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.donationValue = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Mensagem")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.donationMessage,
                          expression: "donationMessage"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "message",
                        placeholder:
                          "Escreva uma mensagem para a equipe do projeto"
                      },
                      domProps: { value: _vm.donationMessage },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.donationMessage = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.donationModalMsg
                ? _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-danger alert-dismissible fade show",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.donationModalMsg) +
                          "\n        "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "alert",
                            "aria-label": "Fechar"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.hideMsg()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "logo" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4 description" }, [
        _c("h2", [
          _vm._v(
            "Conheça alguns Projetos Sociais cadastrados em nossa plataforma!"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Escolha um projeto que toca seu coração e transforme vidas Faça do seu evento um momento de transformação social."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4088f909", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4088f909","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aniversariodobem/AniversarioInvite.vue
// module id = null
// module chunks = 